<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('036003001') !== -1"></button-add>
        <div class="btn-box">
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">领用时间</span>
          <el-date-picker v-model="timevalue"  size="small" type="daterange" style="width: 280px;" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
      </div>
      <input-select selectTitle="物资类目" :selectKey="'categoryCode'" :selectData="categoryTypeList" style="margin:0 20px" @search="search"/>
      <div style="display: flex;justify-content: space-between">
        <input-search  placeholder="物资名称/编号/领用人"  @search="searchKey" />
          <button-export
          :href="exportUrl"
          :beforeDownload="beforeDownload"
          style="margin: 0 0 0 8px"
          v-if="permissionCodes.indexOf('036003004') !== -1"
          download="download.xls"
          value="导出"/>
      </div>
    </div>

    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage"></table-main>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Material";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "material-requisition",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "物资领用"
        }
      ],
      fixTypeList: [],
      tableHead: [
        {
          prop: "personName",
          label: "领用人"
        },
        {
          prop: "enterpriseName",
          label: "领用人单位"
        },
        {
          prop: "materialsName",
          label: "物资名称"
        },
        {
          prop: "materialsNumber",
          label: "物资编号"
        },
        {
          prop: "categoryName",
          label: "物资类目"
        },
        {
          prop: "applyNumber",
          label: "领用数量"
        },
        {
          prop: "applyDate",
          label: "领用时间"
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      tableData: [],
      operationArr: ["modify"],
      exportUrl: "",
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
        startTime: "",
        endTime: "",
        categoryCode: ""
      },
      total: 0,
      timevalue: [],
      categoryTypeList: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
    this.getCategoryList();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportApply}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }&categoryCode=${this.requestData.categoryCode}`;
    },
    getCategoryList(searchKey) {
      this.$axios
        .post(api.getCategoryList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              v.key = v.code;
              v.label = v.categoryName;
            });
            this.categoryTypeList = list;
            this.categoryTypeList.unshift({ key: "", label: "全部" });
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.$axios
        .post(api.getApplyPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          this.tableData = list;
        })
        .catch(errorHandler("获取分页失败"));
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `material_requisition_modify/${code}`
      });
    },
    toAddPage() {
      this.$router.push({
        name: "material-requisition-add"
      });
    },
    deleteSelection() {},
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    }
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/MaterialRequisition/MaterialRequisition.vue